import React, { useEffect, useState } from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import { OpTabs } from 'components/customAntd/DLS/OpTabs/OpTabs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { getRequest } from 'api/apiClient';
import { hasPermission } from 'utils/utils';

import AttendantSignIn from './attendantSignIn/AttendantSignIn';
import AttendantSignOut from './attendantSignOut/AttendantSignOut';
import KioskSignIn from './kioskSignIn/KioskSignIn';
import KioskSignOut from './kioskSignOut/KioskSignOut';

import { VisitorWorkflowType } from 'types/visitorWorkflowTypes';

const Workflow: React.FC = () => {
    const tokenScopeList = useSelector((state: RootState) => state.auth.auth.data[0]?.tokenScopeList || []);
    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);

    const hasSigninconfRead = hasPermission(tokenScopeList, orgId, 'o', 'signinconf:r');
    const hasSignoutconfRead = hasPermission(tokenScopeList, orgId, 'o', 'signoutconf:r');

    const [workflowTypes, setWorkflowTypes] = useState<VisitorWorkflowType[]>([]);
    const [activeKey, setActiveKey] = useState<string>('');

    const { t } = useTranslation();

    useEffect(() => {
        const fetchWorkflowTypes = async () => {
            const visitorWorkflowTypes = await getRequest(`/orgs/${orgId}/visitorWorkflowTypes`);
            setWorkflowTypes(visitorWorkflowTypes.data);
        };

        if (orgId) {
            fetchWorkflowTypes();
        }
    }, [orgId]);

    useEffect(() => {
        if (!hasSigninconfRead) {
            setActiveKey('attendantSignOut');
        }
    }, [hasSigninconfRead]);



    const handleTabChange = (newActiveKey: string) => {
        setActiveKey(newActiveKey);
    };

    const items = workflowTypes
        .map(type => {
            const key = type.languageCode ?? '';

            const show =
                (type.purpose === 'in' && hasSigninconfRead) ||
                (type.purpose === 'out' && hasSignoutconfRead);

            return show && {
                key,
                label: t(key, type.name ?? ''),
                children:
                    type.name === 'Attendant Sign In' ? <AttendantSignIn /> :
                        type.name === 'Attendant Sign Out' ? <AttendantSignOut /> :
                            type.name === 'Kiosk Sign In' ? <KioskSignIn /> :
                                type.name === 'Kiosk Sign Out' ? <KioskSignOut /> :
                                    null,
            };
        })
        .filter(Boolean);

    useEffect(() => {
        if (items.length > 0 && (!activeKey || !items.find(item => item.key === activeKey))) {
            setActiveKey(items[0].key);
        }
    }, [items, activeKey]);


    return (
        <>
            <OpPage title={t('workflow.title')} tooltip={t('workflow.tooltip')} >
                <OpTabs
                    activeKey={activeKey}
                    onChange={handleTabChange}
                    items={items}
                />
            </OpPage>
        </>
    );
}

export default Workflow;
